/**
 * His hand, as data: each digit is a few pencil strokes in a 0.6 × 1 box, `u`
 * along the line of writing and `v` down the page.
 *
 * Handwriting, not a seven-segment readout. The first version drew each digit
 * as up to seven raised 3 mm bars, and under the desk shot it read as a
 * calculator display that had been dropped on the page: the digits were the
 * right digits and the object was the wrong object. A neat hand is what
 * beat 11 is about (`docs/beat-11-plan.md`, *the hand is the difference*), so
 * the strokes are his: straight where a figure is straight, a few points of
 * curve where it bends, one stroke thickness, all on one baseline.
 *
 * One table for both places his hand appears — the ledger's column
 * (`world/office.ts`) and the dates down the margin of his map (`ui/mentalMap.ts`)
 * — so the two cannot drift into two handwritings for one man.
 */
export const PENCIL_DIGITS: Readonly<Record<string, readonly (readonly (readonly [number, number])[])[]>> = {
  '0': [[[0.30, 0], [0.52, 0.12], [0.60, 0.50], [0.52, 0.88], [0.30, 1], [0.08, 0.88], [0, 0.50], [0.08, 0.12], [0.30, 0]]],
  '1': [[[0.14, 0.20], [0.40, 0], [0.40, 1]]],
  '2': [[[0.04, 0.22], [0.18, 0.04], [0.40, 0], [0.57, 0.14], [0.55, 0.38], [0, 1], [0.62, 1]]],
  '3': [[[0.04, 0.10], [0.28, 0], [0.52, 0.10], [0.52, 0.32], [0.24, 0.47], [0.54, 0.60], [0.58, 0.84], [0.34, 1], [0.02, 0.90]]],
  '4': [[[0.46, 1], [0.46, 0], [0, 0.68], [0.62, 0.68]]],
  '5': [[[0.56, 0], [0.10, 0], [0.05, 0.44], [0.34, 0.38], [0.57, 0.54], [0.58, 0.80], [0.38, 1], [0.04, 0.92]]],
  '6': [[[0.50, 0.02], [0.20, 0.26], [0.05, 0.62], [0.12, 0.92], [0.32, 1], [0.52, 0.90], [0.57, 0.68], [0.40, 0.52], [0.16, 0.57], [0.07, 0.70]]],
  '7': [[[0, 0], [0.60, 0], [0.24, 1]]],
  '8': [
    [[0.30, 0.47], [0.52, 0.34], [0.52, 0.12], [0.30, 0], [0.08, 0.12], [0.08, 0.34], [0.30, 0.47]],
    [[0.30, 0.47], [0.56, 0.62], [0.58, 0.86], [0.30, 1], [0.02, 0.86], [0.04, 0.62], [0.30, 0.47]],
  ],
  '9': [[[0.55, 0.36], [0.38, 0.50], [0.14, 0.46], [0.04, 0.24], [0.18, 0.03], [0.42, 0.02], [0.57, 0.20], [0.55, 0.52], [0.44, 1]]],
};
